const milestones = [
  {
    name: "DiscoveryPreEngagement",
    displayName: "Discovery Pre Engagement",
    description: "An initial discovery phase where we provide a short questionnaire to understand your requirements and plan the onboarding process.",
    isInternalMilestone: false,
    visibleToClient: true,
    visibleToIntermediary: true
  },
  {
    name: "DiscoveryExceptions",
    displayName: "Discovery Exceptions",
    description: "During this phase we analyse any exceptions or unique scenarios that may impact the payroll setup.",
    isInternalMilestone: false,
    visibleToClient: true,
    visibleToIntermediary: true
  },
  {
    name: "DataSampleCollection",
    displayName: "Data Sample Collection",
    description: "Where the source payroll system is not a supported migration path, we require sample data from the source system to allow us to map a migration path for your data.",
    isInternalMilestone: true,
    visibleToClient: false,
    visibleToIntermediary: false
  },
  {
    name: "CompanyDataQuestionnaires",
    displayName: "Company Data Questionnaires",
    description: "Complete a short questionnaire covering company information, PAYE references, pension schemes, payroll run schedules, benefits, and payroll contacts so we can configure your payroll environment correctly.",
    isInternalMilestone: false,
    visibleToClient: true,
    visibleToIntermediary: true
  },
  {
    name: "SourceDataCollection",
    displayName: "Source Data Collection",
    description: "Submit full employee payroll data including personal details, tax codes, salaries, deductions, pension information, and year-to-date balances from your current payroll provider.",
    isInternalMilestone: false,
    visibleToClient: true,
    visibleToIntermediary: true
  },
  {
    name: "Migration",
    displayName: "Migration",
    description: "Our team imports your employee and payroll data into the new payroll system and configures the environment based on the information collected during onboarding.",
    isInternalMilestone: true,
    visibleToClient: false,
    visibleToIntermediary: false
  },
  {
    name: "ParallelRun",
    displayName: "Parallel Run",
    description: "We run a test payroll alongside your current payroll provider to verify that calculations, taxes, pensions, and deductions match expected results before going live.",
    isInternalMilestone: true,
    visibleToClient: true,
    visibleToIntermediary: true
  },
  {
    name: "PayrollHandover",
    displayName: "Payroll Handover",
    description: "Final checks are completed and your payroll processing is formally transferred to our team. Any remaining queries or adjustments are resolved at this stage.",
    isInternalMilestone: true,
    visibleToClient: false,
    visibleToIntermediary: false
  },
  {
    name: "GoLive",
    displayName: "Go Live",
    description: "Your payroll is now fully managed by our team. We will process payroll going forward according to the agreed schedule and provide ongoing support.",
    isInternalMilestone: true,
    visibleToClient: true,
    visibleToIntermediary: true
  }
];

export default milestones;